/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/ban-types */
import { LoggerParamMetadata, PROPERTY_KEY_LOG_VALUES } from "./paramMetadata";
import { ReplacerFn } from "./replacerFn";

/**
 * Allows the customization of how this argument is displayed in the method signature that is logged.
 */

export function LogAs<T>(replacer: ReplacerFn<T>): ParameterDecorator
{
    return propertyDescriptor as ParameterDecorator;

    function propertyDescriptor(target: Object, methodName: string | symbol, index: number): void
    {
        const _methodName = methodName || "ctor";
        const existingLogValues: Array<LoggerParamMetadata> = Reflect.getOwnMetadata(PROPERTY_KEY_LOG_VALUES, target, _methodName) || [];

        const metadata = existingLogValues[index] || (existingLogValues[index] = {});
        metadata.replacer = replacer;

        Reflect.defineMetadata(PROPERTY_KEY_LOG_VALUES, existingLogValues, target, _methodName);
    }
}
